import log from 'loglevel';
import remote from 'loglevel-plugin-remote';
import StackTrace from 'stacktrace-js';

export const maskIdOptions = {
  maskWith: 'X',
  unmaskedStartDigits: 1,
  unmaskedEndDigits: 2,
};

const customJSON = (log) => ({
  message: log.message,
  level: log.level.label,
  useragent: navigator.userAgent,
});

const apiPath = process.env.REACT_APP_LOGGER_URL;

remote.apply(log, {
  format: customJSON,
  url: apiPath,
  stacktrace: {
    depth: 10,
  },
});

let debugToggle = false;

export function setDebugLogging(enabled) {
  debugToggle = enabled;
}

export function logError(error) {
  if (debugToggle) {
    log.error('Error:', error);
    log.error('Error Summary:', error?.response?.data?.errorSummary);
    if (error.stack) {
      StackTrace.fromError(error).then((err) => {
        StackTrace.report(err, process.env.REACT_APP_LOGGER_URL, {
          type: 'ui',
          url: window.location.href,
          agent: window.navigator.userAgent,
          date: new Date(),
          msg: err.toString(),
        });
      });
    }
  }
}

export default log;
